import RouteGuard from "components/RouteGuard";
import { getPermissionByPath } from "constants/permissions";
import MustAdminLayout from "layouts/must-admin.layout";
import AnalyticsPage from "pages/analytics";
import AnnouncementsPage from "pages/announcements";
import EditAnnouncementPage from "pages/announcements/edit";
import NewAnnouncementPage from "pages/announcements/new";
import AutoFollowPage from "pages/auto-follow";
import ChatsManagementPage from "pages/chats";
import CreatorsIndexPage from "pages/creators";
import CreateCreatorPage from "pages/creators/create";
import CreatorFetchPage from "pages/creators/fetch";
import DepositSearchPage from "pages/deposits/search";
import DeveloerPage from "pages/developer";
import EarningsPage from "pages/earnings";
import ExplorePage from "pages/explore";
import GuestModePage from "pages/guest-mode";
import PointsSummaryPage from "pages/points-summary";
import ClaimPreRegistrationPage from "pages/pre-registration/claim";
import ReviewVideoPage from "pages/review";
import ReviewPostsPage from "pages/review/posts";
import ShortVideosPage from "pages/short-videos";
import TransactionSearchPage from "pages/transactions/search";
import UserSearchPage from "pages/users/search";
import { Route, Routes } from "react-router-dom";

export default function GeneralRoutes() {
  return (
    <Routes>
      <Route path="/" element={<MustAdminLayout />}>
        <Route
          index
          element={
            <RouteGuard permission={getPermissionByPath("/analytics")}>
              <AnalyticsPage />
            </RouteGuard>
          }
        />
        <Route
          path="review/videos"
          element={
            <RouteGuard permission={getPermissionByPath("/review/videos")}>
              <ReviewVideoPage />
            </RouteGuard>
          }
        />
        <Route
          path="review/posts"
          element={
            <RouteGuard permission={getPermissionByPath("/review/posts")}>
              <ReviewPostsPage />
            </RouteGuard>
          }
        />
        <Route
          path="analytics"
          element={
            <RouteGuard permission={getPermissionByPath("/analytics")}>
              <AnalyticsPage />
            </RouteGuard>
          }
        />
        <Route
          path="guest-mode"
          element={
            <RouteGuard permission={getPermissionByPath("/guest-mode")}>
              <GuestModePage />
            </RouteGuard>
          }
        />
        <Route
          path="creators"
          element={
            <RouteGuard permission={getPermissionByPath("/creators")}>
              <CreatorsIndexPage />
            </RouteGuard>
          }
        />
        <Route
          path="creators/:id"
          element={
            <RouteGuard permission={getPermissionByPath("/creators")}>
              <CreatorFetchPage />
            </RouteGuard>
          }
        />
        <Route
          path="creators/new"
          element={
            <RouteGuard permission={getPermissionByPath("/creators")}>
              <CreateCreatorPage />
            </RouteGuard>
          }
        />
        <Route
          path="users/search"
          element={
            <RouteGuard permission={getPermissionByPath("/users/search")}>
              <UserSearchPage />
            </RouteGuard>
          }
        />
        <Route
          path="deposits/search"
          element={
            <RouteGuard permission={getPermissionByPath("/deposits/search")}>
              <DepositSearchPage />
            </RouteGuard>
          }
        />
        <Route
          path="transactions/search"
          element={
            <RouteGuard permission={getPermissionByPath("/transactions/search")}>
              <TransactionSearchPage />
            </RouteGuard>
          }
        />
        <Route
          path="announcements"
          element={
            <RouteGuard permission={getPermissionByPath("/announcements")}>
              <AnnouncementsPage />
            </RouteGuard>
          }
        />
        <Route
          path="explore"
          element={
            <RouteGuard permission={getPermissionByPath("/explore")}>
              <ExplorePage />
            </RouteGuard>
          }
        />
        <Route
          path="announcements/new"
          element={
            <RouteGuard permission={getPermissionByPath("/announcements")}>
              <NewAnnouncementPage />
            </RouteGuard>
          }
        />
        <Route
          path="announcements/:id/edit"
          element={
            <RouteGuard permission={getPermissionByPath("/announcements")}>
              <EditAnnouncementPage />
            </RouteGuard>
          }
        />
        <Route
          path="developer"
          element={
            <RouteGuard permission={getPermissionByPath("/developer")}>
              <DeveloerPage />
            </RouteGuard>
          }
        />
        <Route
          path="pre-registration-reward/claim"
          element={
            <RouteGuard permission={getPermissionByPath("/pre-registration-reward/claim")}>
              <ClaimPreRegistrationPage />
            </RouteGuard>
          }
        />
        <Route
          path="earnings"
          element={
            <RouteGuard permission={getPermissionByPath("/earnings")}>
              <EarningsPage />
            </RouteGuard>
          }
        />
        <Route
          path="auto-follow"
          element={
            <RouteGuard permission={getPermissionByPath("/auto-follow")}>
              <AutoFollowPage />
            </RouteGuard>
          }
        />
        <Route
          path="short-videos"
          element={
            <RouteGuard permission={getPermissionByPath("/short-videos")}>
              <ShortVideosPage />
            </RouteGuard>
          }
        />
        <Route
          path="chats"
          element={
            <RouteGuard permission={getPermissionByPath("/chats")}>
              <ChatsManagementPage />
            </RouteGuard>
          }
        />
        <Route
          path="points-summary"
          element={
            <RouteGuard permission={getPermissionByPath("/points-summary")}>
              <PointsSummaryPage />
            </RouteGuard>
          }
        />
      </Route>
    </Routes>
  );
}
